  import { Component, ErrorInfo, ReactNode } from "react";
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";
  import FehlerModal from "./app/components/FehlerModal";

  function recordError(payload: Record<string, unknown>) {
    try {
      const existing = JSON.parse(localStorage.getItem("debug-errors") || "[]");
      existing.push({ ...payload, ts: new Date().toISOString(), href: location.href });
      localStorage.setItem("debug-errors", JSON.stringify(existing.slice(-20)));
    } catch {}
  }

  window.addEventListener("error", (e) => {
    recordError({
      kind: "window.error",
      message: e.message,
      filename: e.filename,
      lineno: e.lineno,
      colno: e.colno,
      stack: e.error?.stack,
    });
  });

  window.addEventListener("unhandledrejection", (e) => {
    recordError({
      kind: "unhandledrejection",
      reason: String(e.reason),
      stack: (e.reason as { stack?: string })?.stack,
    });
  });

  // Das äußerste Fangnetz: Was hier ankommt, ist am Router vorbeigegangen — ein Fehler
  // im Router selbst oder in einem Anbieter darüber. Ohne diese Ebene bliebe eine weiße
  // Seite ohne jede Meldung.
  class RootErrorBoundary extends Component<
    { children: ReactNode },
    { error: Error | null; componentStack: string | null }
  > {
    state: { error: Error | null; componentStack: string | null } = { error: null, componentStack: null };
    static getDerivedStateFromError(error: Error) {
      return { error, componentStack: null };
    }
    componentDidCatch(error: Error, info: ErrorInfo) {
      recordError({
        kind: "react.error-boundary",
        message: error.message,
        stack: error.stack,
        componentStack: info.componentStack,
      });
      this.setState({ componentStack: info.componentStack || null });
    }
    render() {
      if (this.state.error) {
        return (
          <FehlerModal
            fehler={this.state.error}
            componentStack={this.state.componentStack}
            quelle="root"
          />
        );
      }
      return this.props.children;
    }
  }

  createRoot(document.getElementById("root")!).render(
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  );
